import { combineReducers } from 'redux'
import { WebhookTypes } from '../../action_types'
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from 'src/utils/helpers'

function all(state = {}, action) {
  switch (action.type) {
    case WebhookTypes.GET_WEBHOOKS_SUCCESS:
      return { ...state, ...arrayToObject(action.data.results) }
    case WebhookTypes.GET_WEBHOOK_SUCCESS:
    case WebhookTypes.CREATE_WEBHOOK_SUCCESS:
    case WebhookTypes.UPDATE_WEBHOOK_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      }
    case WebhookTypes.DELETE_WEBHOOK_SUCCESS:
      const { [action.id]: _, ...newState } = state
      return newState
    default:
      return state
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case WebhookTypes.GET_WEBHOOKS_SUCCESS:
      return action.data.results
    case WebhookTypes.CREATE_WEBHOOK_SUCCESS:
      return insertItem(state, action.data)
    case WebhookTypes.UPDATE_WEBHOOK_SUCCESS:
      return updateObjectInArray(state, action.data)
    case WebhookTypes.DELETE_WEBHOOK_SUCCESS:
      return removeItem(state, action.id)
    default:
      return state
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case WebhookTypes.GET_WEBHOOKS_SUCCESS:
      const { results, ...rest } = action.data
      return { ...state, ...rest }
    case WebhookTypes.DELETE_WEBHOOK_SUCCESS: {
      const { count } = state
      return { ...state, count: count - 1 }
    }
    case WebhookTypes.CREATE_WEBHOOK_SUCCESS: {
      const { count } = state
      return { ...state, count: count + 1 }
    }
    default:
      return state
  }
}

function webhook_events(state = [], action) {
  switch (action.type) {
    case WebhookTypes.GET_WEBHOOK_EVENTS_SUCCESS:
      return action.data
    default:
      return state
  }
}

function createdWebhook(state = {}, action) {
  switch (action.type) {
    case WebhookTypes.CREATE_WEBHOOK_SUCCESS:
      return action.data
    default:
      return state
  }
}

export default combineReducers({
  all,
  ui,
  meta,
  webhook_events,
  createdWebhook,
})
